<script setup lang="ts">
</script>

<template>
  <UApp>
    <NavHeader />

    <UMain>
      <NuxtPage />
    </UMain>

    <NavFooter />
  </UApp>
</template>
